<template>
  <div class="newsItem cur" @click="toDetail">
    <span class="val elli">{{detail.name}}</span>
    <span class="time">{{detail.time || detail.createtime.substr(0,10)}}</span>
  </div>
</template>

<script>
  export default {
    props: {
      detail: {name:'', time:''}
    },
    created() {
      
    },
    methods: {
      toDetail() {
        this.$emit('ok')
      }
    },
  }
</script>

<style lang="scss" scoped>
  .newsItem {
    margin-left: 0.08rem;
    padding: 0.9em 0;
    display: flex;
    justify-content: space-between;
    font-size: .16rem;
    // a {


    .val {
      position: relative;
      min-width: 0;
      padding-left: .12rem;

      &::after {
        content: "";
        display: block;
        width: .03rem;
        height: .03rem;
        background-color: #333;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }
    }

    .time {
      color: #999999;
      margin-left: 0.1rem;
      width: 1.6rem;
      text-align: right;
    }

    &:hover .val {
      color: #2F915D;
    }

    &:hover .val::after {
      background-color: #2F915D;
    }
  }
  
  @media only screen and (max-width: 767px) {
    .newsItem{padding:0.6em 0}
  }
  // }
</style>